import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import ProductSignature from './pages/ProductSignature';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import MessengerChat from './components/MessengerChat';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminCustomers from './pages/admin/AdminCustomers';
import AdminCategories from './pages/admin/AdminCategories';
import AdminBrands from './pages/admin/AdminBrands';
import AdminPromotions from './pages/admin/AdminPromotions';
import AdminTownshipDelivery from './pages/admin/AdminTownshipDelivery';
import AdminWholesaleApplications from './pages/admin/AdminWholesaleApplications';
import AdminExchangeRequests from './pages/admin/AdminExchangeRequests';
import AdminOrders from './pages/admin/AdminOrders';
import AdminManualOrder from './pages/admin/AdminManualOrder';
import AdminProfile from './pages/admin/AdminProfile';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminBanners from './pages/admin/AdminBanners';
import AdminSettings from './pages/admin/AdminSettings';

import WholesaleRegistration from './pages/WholesaleRegistration';
import Exchange from './pages/Exchange';
import Orders from './pages/Orders';
import POSLayout from './pages/pos/POSLayout';
import POSTerminal from './pages/pos/POSTerminal';
import POSSaleHistory from './pages/pos/POSSaleHistory';
import POSHeldSales from './pages/pos/POSHeldSales';
import POSInventory from './pages/pos/POSInventory';
import InventoryProductDetail from './pages/pos/InventoryProductDetail';
import POSSuppliers from './pages/pos/POSSuppliers';
import POSPurchases from './pages/pos/POSPurchases';
import POSReports from './pages/pos/POSReports';
import POSBarcodePrint from './pages/pos/POSBarcodePrint';
import './App.css';
import { CartProvider } from './context/CartContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isPosRoute = location.pathname.startsWith('/pos');
  
  return (
    <div className={`min-h-screen ${isPosRoute ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {!isPosRoute && <ScrollToTop />}
      {!isAdminRoute && !isPosRoute && <Header />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/product-signature" element={<ProductSignature />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/wholesale-registration" element={<WholesaleRegistration />} />
        <Route path="/exchange" element={<Exchange />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        
        {/* POS Routes */}
        <Route path="/pos" element={<POSLayout />}>
          <Route index element={<POSTerminal />} />
          <Route path="sales" element={<POSSaleHistory />} />
          <Route path="held" element={<POSHeldSales />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="brands" element={<AdminBrands />} />
          <Route path="promotions" element={<AdminPromotions />} />
          <Route path="coupons" element={<AdminCoupons />} />
          <Route path="banners" element={<AdminBanners />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="orders/create" element={<AdminManualOrder />} />
          <Route path="customers" element={<AdminCustomers />} />

          <Route path="wholesale-applications" element={<AdminWholesaleApplications />} />
          <Route path="exchange-requests" element={<AdminExchangeRequests />} />
          <Route path="township-delivery" element={<AdminTownshipDelivery />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="inventory" element={<POSInventory />} />
          <Route path="inventory/:id" element={<InventoryProductDetail />} />
          <Route path="suppliers" element={<POSSuppliers />} />
          <Route path="purchases" element={<POSPurchases />} />
          <Route path="pos-sales" element={<POSSaleHistory />} />
          <Route path="reports" element={<POSReports />} />
          <Route path="barcode-labels" element={<POSBarcodePrint />} />
        </Route>
      </Routes>
      {!isAdminRoute && !isPosRoute && <Footer />}
      {!isPosRoute && <BackToTop />}
      {!isAdminRoute && !isPosRoute && <MessengerChat pageId="529866840201071" />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <CartProvider>
        <AppContent />
      </CartProvider>
    </Router>
  );
}

export default App;
